import React, {Component} from 'react';
import {Card, Table} from 'semantic-ui-react';
import _ from 'lodash';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';
import {getMonthName} from '../../../../../common/util/date';
import './table.scss';

class SalesAndBudgetsList extends Component {
  getFormattedData() {
    const {data} = this.props;
    const budgetsByYear = _.groupBy(data.budgets, (sale) => {
      return sale.year;
    });
    const salesByYear = _.groupBy(data.sales, (sale) => {
      return sale.year;
    });
    const complianceByYear = _.groupBy(data.compliance, (compliance) => {
      return compliance.year;
    });

    const dataFormatted = [];
    Object.keys(budgetsByYear).forEach((year) => {
      const budgets = budgetsByYear[year];
      const sales = salesByYear[year];
      const compliance = complianceByYear[year];

      dataFormatted.push({year, budgets, sales, compliance});
    });
    return dataFormatted;
  }

  getTotal(values) {
    return values.reduce((accumulator, currentValue) => {
      return accumulator + (currentValue.amount || 0);
    }, 0);
  }

  getCompliance(sales, budget) {
    const compliance = (sales / budget) * 100;
    return getNumericValue(compliance, 2);
  }

  getCellValue(value, type) {
    if (type === 'percentage') {
      return `${getNumericValue(value, 2)}%`;
    }

    return `$${getNumericValue(value, 2)}`;
  }

  renderTitleByColumn(list) {
    return list.map((element, index) => {
      return (
        <Table.HeaderCell key={index} textAlign='center'>
          {getMonthName(element.month)}
        </Table.HeaderCell>
      );
    });
  }

  renderRowInfo(list, {rowTitle, type, total}) {
    return (
      <Table.Row>
        <Table.Cell textAlign='left'>{rowTitle}</Table.Cell>
        {this.renderDataByMonth(list, type)}
        {this.renderTotal(total, type)}
      </Table.Row>
    );
  }

  renderTotal(total, type) {
    if (!total) {
      return <Table.Cell />;
    }

    const value = this.getCellValue(total, type);

    return (
      <Table.Cell textAlign='right' className='totals-column'>
        {value}
      </Table.Cell>
    );
  }

  renderDataByMonth(list = [], type) {
    return list.map((element, index) => {
      const value = element.amount ?
        `${this.getCellValue(element.amount, type)}` :
        '';
      return (
        <Table.Cell key={index} textAlign='right'>
          {value}
        </Table.Cell>
      );
    });
  }

  renderInfo() {
    const dataFormatted = this.getFormattedData();
    return dataFormatted.map((element, index) => {
      const totalSales = this.getTotal(element.sales);
      const totalBudget = this.getTotal(element.budgets);
      const totalCompliance = this.getCompliance(totalSales, totalBudget);

      return (
        <div className='table-container'>
          <Table striped key={index}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>
                  {element.year}
                </Table.HeaderCell>
                {this.renderTitleByColumn(element.budgets)}
                <Table.HeaderCell textAlign='center' className='totals-column'>
                  TOTAL
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.renderRowInfo(element.budgets, {
                'rowTitle': 'Presupuesto',
                'total': totalBudget,
              })}
              {this.renderRowInfo(element.sales, {
                'rowTitle': 'Ventas',
                'total': totalSales,
              })}
              {this.renderRowInfo(element.compliance, {
                'rowTitle': 'Cumplimiento',
                'total': totalCompliance,
                'type': 'percentage',
              })}
            </Table.Body>
          </Table>
        </div>
      );
    });
  }

  render() {
    return (
      <Card fluid raised className='sales-vs-budgets-by-dealer'>
        {this.renderInfo()}
      </Card>
    );
  }
}


export default SalesAndBudgetsList;
